export default "__VITE_ASSET__DsSO$mKe__"